export const STATUS_MAPPER = {
  DISPONIVEL: 'Disponível',
  PAUSA: 'Pausa',
  INDISPONIVEL: 'Indisponível',
  LIVRE: 'Livre',
  EM_ATENDIMENTO: 'Em atendimento',
  POS_ATENDIMENTO: 'Pós-atendimento',
  ENCERRADO: 'Encerrado',
};
